import { format, parse } from 'date-fns';
import { es } from "date-fns/locale";
export const formatTextDate = (date: string) => {
    const currentDate = parse(date, 'd/M/yyyy', new Date());

    const formatedDate = format(currentDate, "EEEE, d 'de' MMMM 'de' yyyy", { locale:  es});
    return formatedDate;
}